// Static engineered backdrop — a faint blueprint grid with a warm signal glow.
// Pure CSS: no canvas, no rAF loop, no mouse listeners. Cheap on battery and
// safe under prefers-reduced-motion (nothing here animates).
const GridBackground = () => (
  <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0 bg-ink">
    <div className="absolute inset-0 grid-field" />
    <div className="absolute inset-0 grid-glow" />
  </div>
);

export default GridBackground;
